export default String.raw`

<div class="customer-info">
    <div class="customer-info__header">
        <strong>{{ translations.ContactData }}</strong>
        <div class="edit container-js">
            <button class="pure-button replace-template-js set-focus-trap-js" data-template="partials/customer-profile/your-account/employee-update.html" data-container=".employee-data-js">
                <span class="container-reload-js">{{ translations.Edit }}</span>
            </button>
        </div>
    </div>
    <div class="customer-info__container">
        <div class="customer-info__content">
        <div class="title">{{ translations.NameAndSurname }}</div>
            {% if customer.Employee.Name != ''-%}
            <span>{{customer.Employee.Name}} {{customer.Employee.Name2}}</span>
            {% else -%}
                {% if customer.Employee.Name == '' and customer.Company == true -%}
            <span></span>
                {% else -%}
                    {% if {{customer.Address.Name2}} != '' -%}
            <span>{{customer.Address.Name}} {{customer.Address.Name2}}</span>
                    {% else -%}
            <span>{{customer.Address.Name}}</span>
                    {% endif -%}
                {% endif -%}
            {% endif -%}
        </div>
        <div class="customer-info__content">
            <div class="title">{{ translations.Phone }}</div>
        {% if customer.Employee.PhoneNo != '' or customer.Address.PhoneNo != '' -%}
                {% if customer.Employee.PhoneNo != '' -%}
                <span>{{customer.Employee.PhoneNo}}</span>
                {% else -%}
                <span>{{ customer.Address.PhoneNo }}</span>
                {% endif -%}
        {% endif %}
        </div>
    </div>
</div>
<div class="customer-info">
    <div class="customer-info__header">
        <strong>{{ translations.Email }}</strong>
        <div class="edit container-js">
            <button class="pure-button replace-template-js set-focus-trap-js" data-template="partials/customer-profile/your-account/change-email-form.html" data-container=".employee-data-js">
                <span class="container-reload-js">{{ translations.Edit }}</span>
            </button>
        </div>
    </div>
    <div class="customer-info__container">
        <div class="customer-info__content">
            <div class="title">{{ translations.Email }}</div>
            <span class="email-container">
                {{customer.Employee.Email}}
            </span>
        </div>
    </div>
</div>
<div class="customer-info">
    <div class="customer-info__header">
        <strong>{{ translations.Password }}</strong>
        <div class="edit container-js">
            <button class="pure-button replace-template-js set-focus-trap-js" data-template="partials/customer-profile/your-account/change-pass-form.html" data-container=".employee-data-js">
                <span class="container-reload-js">{{ translations.Edit }}</span>
            </button>
        </div>
    </div>
    <div class="customer-info__container">
        <div class="customer-info__content">
            <label for="customer-password" class="title">{{ translations.CurrentPassword }}</label>
            <input id="customer-password" type="password" value="**************" name="placeholder" disabled>
        </div>
    </div>
</div>
<div class="social-container">
    {% if config.External.Facebook or config.External.Google  -%}
        <h2>{{ translations.ExternalWebsites }}</h2>
        <div class="CustomerContentSection">
            {% if customer-profile.LinkedAccounts[0] -%}
                {% assign fbConnect = 0 -%}
                {% assign googleConnect = 0 -%}
                {% for account in customer-profile.LinkedAccounts -%}
                    {% if account.Service == 'Facebook' and config.External.Facebook and config.External.Facebook.AppID != '' %}
                        <div tabindex="0" role="button" id="disconnect-fb" class="CustomerSocialButton CustomerSocialButtonFacebook">
                            <img class="GFbLinkIcon" src="css/img/alo.gif" data-src="https://static.comarchesklep.pl/files/img/Fbicon.png" width="130" height="130">
                            <span>{{translations.Disconnect_Fb}}</span>
                        </div>
                        {% assign fbConnect = 1 -%}
                    {% elsif account.Service == 'Google' and config.External.Google and config.External.Google.ClientID != '' %}
                        <div tabindex="0" role="button" id="unlinkGoogleAccount" class="CustomerSocialButton CustomerSocialButtonGoogle">
                            <img class="GFbLinkIcon" src="css/img/alo.gif" data-src="https://static.comarchesklep.pl/files/img/googleIcon.png" width="130" height="130">
                            <span>{{translations.Disconnect_Google}}</span>
                        </div>
                        {% assign googleConnect = 1 -%}
                    {% endif %}
                {% endfor %}
                {% if fbConnect == 0 and config.External.Facebook and config.External.Facebook.AppID != '' %}
                    <div tabindex="0" role="button" id="connect-fb" class="CustomerSocialButton CustomerSocialButtonFacebook">
                        <img class="GFbLinkIcon" src="css/img/alo.gif" data-src="https://static.comarchesklep.pl/files/img/Fbicon.png" width="130" height="130">
                        <span>{{translations.ConnectFb}}</span>
                    </div>
                {% endif %}
                {% if googleConnect == 0 and config.External.Google and config.External.Google.ClientID != '' %}
                    <div tabindex="0" role="button" id="linkGoogleAccount" class="CustomerSocialButton CustomerSocialButtonGoogle">
                        <img class="GFbLinkIcon" src="css/img/alo.gif" data-src="https://static.comarchesklep.pl/files/img/googleIcon.png" width="130" height="130">
                        <span>{{translations.ConnectGoogle}}</span>
                    </div>
                {% endif %}
            {% else %}
                {% if config.External.Facebook and config.External.Facebook.AppID != '' %}
                    <div tabindex="0" role="button" id="connect-fb" class="CustomerSocialButton CustomerSocialButtonFacebook">
                        <img class="GFbLinkIcon" src="css/img/alo.gif" data-src="https://static.comarchesklep.pl/files/img/Fbicon.png" width="130" height="130">
                        <span>{{translations.ConnectFb}}</span>
                    </div>
                {% endif %}
                {% if config.External.Google and config.External.Google.ClientID != '' %}
                    <div tabindex="0" role="button" id="linkGoogleAccount" class="CustomerSocialButton CustomerSocialButtonGoogle">
                        <img class="GFbLinkIcon" src="css/img/alo.gif" data-src="https://static.comarchesklep.pl/files/img/googleIcon.png" width="130" height="130">
                        <span>{{translations.ConnectGoogle}}</span>
                    </div>
                {% endif %}
            {% endif %}
        </div>
    {% endif -%}
</div>
`